export default "__VITE_ASSET__BhHI_hC1__"